import React, { useContext } from 'react';
import * as styles from './index.module.less';
import { GOODS_TYPE } from '@/modules/pricing/utils';
import { CLASS_MAP } from '../..';
import { PricingContext } from '@/modules/pricing-v2/provider';

interface IProps {
  type: GOODS_TYPE;
  index: number;
}

const CardTopTips = ({ type, index }: IProps) => {
  const { lang } = useContext(PricingContext);

  return (
    <div
      style={{
        gridArea: `t${index}`,
      }}
      className={`${styles.card_top_tips} ${styles[CLASS_MAP[type]]}`}
    >
      {lang === 'ja' && type === GOODS_TYPE.TEAM && <div className={styles.team_tips}>オススメ</div>}
    </div>
  );
};
export default CardTopTips;
